<script>
import { userTypes, orderTypes } from "@/store/types/types.js";
import * as moment from "moment";
export default {
  name: "CustomerModal",
  props: {
    userNotInList: {
      type: Object
    },
    index: {
      required: true,
      type: Number
    },
    title: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      user: {
        name: "",
        is_tableware: 0,
        phone: {
          main: "",
          other: []
        },
        address: {
          main: {
            city: "台南市",
            district: "東區",
            street: ""
          },
          other: []
        },
        fixed_time: [],
        default_order: [],
        unpaid_prepay: 0,
        prepay: [0, 0, 0, 0, 0, 0],
        order_comment: "",
        kitchen_comment: "",
        delivery_comment: ""
      },
      fixed_time: [false, false, false, false, false],
      districtList: [
        "東區",
        "歸仁區",
        "仁德區",
        "永康區",
        "安南區",
        "北區",
        "安平區",
        "南區",
        "中西區"
      ],
      weekday: ["一", "二", "三", "四", "五"],
      isDuplicateNumber: false
    };
  },
  computed: {
    list() {
      return this.$store.getters[userTypes.getters.getUserList];
    }
  },
  methods: {
    checkPhoneNumber(phone) {
      let data = {
        q: phone
      };
      this.$store
        .dispatch(userTypes.actions.QUERY_USER_PHONE, data)
        .then(res => {
          if (res.length) {
            return (this.isDuplicateNumber = true);
          }
          return (this.isDuplicateNumber = false);
        });
    },
    convertToPriceByFixedDay(item) {
      switch (item.description) {
        case "2～3人":
          item.price = 400;
          break;
        case "2～3人優惠":
          item.price = 360;
          break;
        case "2～3人優惠（月）":
          item.price = 340;
          break;
        case "3～4人":
          item.price = 500;
          break;
        case "3～4人優惠":
          item.price = 450;
          break;
        case "3～4人優惠（月）":
          item.price = 425;
          break;
        case "自訂":
          item.price = 0;
          break;
        default:
          item.price = 0;
          break;
      }
      return item;
    },
    addWeekOrder() {
      let orderList = JSON.parse(JSON.stringify(this.user.default_order));
      orderList = orderList.map(order => {
        order.delivered_at = null;
        order.user_id = this.index;
        order.is_prepay = 0;
        order.address =
          this.user.address.main.city +
          this.user.address.main.district +
          this.user.address.main.street;
        order.phone = this.user.phone.main;
        return order;
      });
      if (!orderList.length) return alert("請新增預設訂單！");
      //過濾今天以前的日期
      let now = moment().days();
      let nowTime = moment().format("HH");
      let fixedDays = this.checkboxToFixedTime().filter(day => {
        return now <= day;
      });
      if (16 <= nowTime) fixedDays = fixedDays.filter(day => day !== now);
      fixedDays = fixedDays.map(day => {
        if (moment(now).week() === 1) {
          return moment()
            .add(1, "d")
            .isoWeekday(day)
            .format("YYYY-MM-DD");
        }
        return moment()
          .isoWeekday(day)
          .format("YYYY-MM-DD");
      });

      //let promises = [];
      let list = [];
      fixedDays.forEach(day => {
        orderList.forEach(order => {
          let copyOrder = { ...order };
          copyOrder.delivered_at = day;
          this.convertToPriceByFixedDay(copyOrder);
          list.push(copyOrder);
        });
      });
      this.$store.dispatch(orderTypes.actions.ADD_ORDER, list).then(() => {
        alert(`已成功新增訂單！`);
      });

      // orderList.forEach(detail => {
      //   fixedDays.forEach(async day => {
      //     let order = JSON.parse(JSON.stringify(detail));
      //     order.delivered_at = day;
      //     this.convertToPriceByFixedDay(order);
      //     let promise = this.$store
      //       .dispatch(orderTypes.actions.ADD_ORDER, order)
      //       .then(res => {
      //         return res.data.result;
      //       });
      //     promises.push(promise);
      //   });
      // });
      // Promise.all(promises).then(() => {
      //   alert(`已成功新增訂單！`);
      // });
    },
    addAddress() {
      if (!this.user.address.main.street) {
        alert("請先輸入主要住址");
        return;
      }
      const data = {
        city: this.user.address.main.city,
        district: "東區",
        street: ""
      };
      if (!this.user.address.other) {
        this.$set(this.user.address, "other", []);
      }
      this.user.address.other.push(data);
    },
    addPhone() {
      if (!this.user.phone.main) {
        alert("請先輸入主要電話");
        return;
      }
      if (!this.user.phone.other) {
        this.$set(this.user.phone, "other", []);
      }
      this.user.phone.other.push("");
    },
    addOrder() {
      let data = {
        description: "",
        price: "",
        rice: 0,
        customized_label: "",
        customized_price: ""
      };
      this.user.default_order.push(data);
    },
    deleteAddress(index) {
      this.user.address.other.splice(index, 1);
      this.district.other.splice(index, 1);
      this.city.other.splice(index, 1);
    },
    deletePhone(index) {
      this.user.phone.other.splice(index, 1);
    },
    deleteOrder(index) {
      this.user.default_order.splice(index, 1);
    },
    fixedTimeToCheckbox() {
      const oldFixedTime = this.user.fixed_time;
      const fixed_time = [false, false, false, false, false];
      this.fixed_time = fixed_time.map((weekday, index) => {
        return oldFixedTime.some(day => {
          return index + 1 == day ? (day = true) : (day = false);
        });
      });
    },
    checkFixedTimeEqual(newTime) {
      if (JSON.stringify(newTime) == "[]") return false;
      if (newTime.length !== this.user.fixed_time.length) return false;
      this.user.fixed_time.sort((a, b) => a - b);
      newTime.sort((a, b) => a - b);
      return newTime.every((time, index) => {
        return time === Number(this.user.fixed_time[index]);
      });
    },
    checkboxToFixedTime() {
      let time = this.fixed_time;
      let indexArr = [];
      time.filter((item, index) => {
        item ? indexArr.push(index + 1) : null;
      });
      return indexArr;
    },
    checkDefalutOrderEqual() {
      this.$store
        .dispatch(userTypes.actions.QUERY_SINGLE_USER, this.index)
        .then(data => {
          let editBeforeOrder = JSON.stringify(data.default_order);
          let editAfterOrder = JSON.stringify(this.user.default_order);
          if (editAfterOrder === editBeforeOrder) return true;
          return false;
        });
    },
    reset() {
      this.user = {
        id: "",
        name: "",
        is_tableware: 0,
        phone: {
          main: "",
          other: []
        },
        address: {
          main: {
            city: "台南市",
            district: "東區",
            street: ""
          },
          other: []
        },
        fixed_time: [],
        default_order: [],
        prepay: [0, 0, 0, 0, 0, 0],
        unpaid_prepay: 0,
        order_comment: " ",
        kitchen_comment: " ",
        delivery_comment: " "
      };
      this.fixed_time = [false, false, false, false, false];
      this.isDuplicateNumber = false;
    },
    editUser() {
      let indexArr = this.checkboxToFixedTime();
      this.checkFixedTimeEqual(indexArr)
        ? delete this.user.fixed_time
        : (this.user.fixed_time = indexArr);
      this.$store
        .dispatch(userTypes.actions.QUERY_SINGLE_USER, this.index)
        .then(data => {
          let editBeforeOrder = JSON.stringify(data.default_order);
          let editAfterOrder = JSON.stringify(this.user.default_order);
          if (editAfterOrder === editBeforeOrder)
            delete this.user.default_order;
        })
        .then(() => {
          delete this.user.state;
          this.$store
            .dispatch(userTypes.actions.EDIT_USER, this.user)
            .then(() => {
              this.$emit("updateList");
              this.$emit("resetIndex", -1);
            });
        });
    },
    createUser() {
      let indexArr = this.checkboxToFixedTime();
      this.checkFixedTimeEqual(indexArr)
        ? delete this.user.fixed_time
        : (this.user.fixed_time = indexArr);
      delete this.user.state;
      this.$store
        .dispatch(userTypes.actions.ADD_USER, this.user)
        .then(res => {
          return this.$store.dispatch(
            userTypes.actions.QUERY_SINGLE_USER,
            res.user_id
          );
        })
        .then(user => {
          this.$store.dispatch(userTypes.actions.QUERY_USER_LIST).then(() => {
            this.$parent.printUser(user);
            this.reset();
          });
        });
    },
    convertToPrice() {
      this.user.default_order.forEach(order => {
        switch (order.description) {
          case "2～3人":
            order.price = 400;
            break;
          case "2～3人優惠":
            order.price = 360;
            break;
          case "2～3人優惠（月）":
            order.price = 340;
            break;
          case "3～4人":
            order.price = 500;
            break;
          case "3～4人優惠":
            order.price = 450;
            break;
          case "3～4人優惠（月）":
            order.price = 425;
            break;
          default:
            order.price = 0;
            break;
        }
        return order;
      });
    },
    checkData() {
      let save = true;
      let checkfixedTime = this.fixed_time.some(day => day === true);
      if (
        !this.user.name ||
        !this.user.address.main.district ||
        !this.user.address.main.street ||
        !this.user.phone.main
      ) {
        alert("請檢查姓名、地址、電話，是否都有填寫。");
        save = false;
        return;
      }
      if (this.user.phone.main.length !== 10) {
        alert("電話缺碼，請重新確認！");
        save = false;
        return;
      }
      if (checkfixedTime && !this.user.default_order.length) {
        alert("請輸入預設訂單。");
        save = false;
        return;
      }
      if (
        checkfixedTime &&
        this.user.default_order.length &&
        !this.user.default_order[0].description
      ) {
        alert("請點選預設訂單的下拉選單。");
        save = false;
        return;
      }
      if (!checkfixedTime && this.user.default_order.length) {
        alert("請點選固定送餐的日期。");
        save = false;
        return;
      }
      let notFillAllPrepay = this.user.prepay.some(prepay => prepay === "");
      if (notFillAllPrepay) {
        alert("預付不能為空，須填為 0！");
        save = false;
        return;
      }
      if (this.user.unpaid_prepay === "") {
        alert("預付未付不能為空，須填為 0！");
        save = false;
        return;
      }
      return save;
    },
    saveData() {
      if (this.checkData()) {
        this.convertToPrice();
        this.index >= 0 ? this.editUser() : this.createUser();
        this.$jquery("#AddCustomerModal").modal("hide");
      }
      return;
    },
    filterUser() {
      return this.list.filter(user => user.id === this.index);
    }
  },
  watch: {
    index(val) {
      if (val >= 0) {
        let user = this.list.filter(user => user.id === this.index)[0];
        if (!user) {
          this.user = JSON.parse(JSON.stringify(this.userNotInList));
          this.fixedTimeToCheckbox();
          return;
        }
        this.user = user;
        this.fixedTimeToCheckbox();
        return;
      }
      this.reset();
    },
    user(val) {
      this.user = val;
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"/>
